import {
  StyleSheet,
} from 'react-native';

export default StyleSheet.create({
  details_table: {
  },
  details_row: {
    flexDirection: 'row',
    marginBottom: 25,
    justifyContent: 'space-between',
  },
  details_col1: {
    textAlign: 'left',
  },
  details_col2: {
    textAlign: 'right',
    marginLeft: 40,
  },
});
